import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static values = { buttonId: String, url: String };
  static targets = ["tab", "dialog"];

  connect() {
    // ESC
    this.dialogTargets.forEach((dialog) => {
      dialog.addEventListener("cancel", this.modalClose.bind(this));
    });
  }

  modalShow(targetId) {
    const targetModal = document.getElementById(targetId);
    $(targetModal).fadeIn(300);
    targetModal.showModal();
    targetModal.classList.add("is-open");
    targetModal.setAttribute("tabindex", "-1");
    targetModal.focus();
  }

  //オーバーレイクリックで閉じる
  overlay(e) {
    var target = $(e.target);
    if (!target.closest(".js-modal-content").length) {
      this.modalClose();
    }
  }

  //モーダル閉じる処理
  modalClose() {
    var openModal = document.querySelector(".js-modal.is-open");

    if (openModal) {
      $(openModal).fadeOut(300);
      setTimeout(function () {
        openModal.close();
      }, 300);
      openModal.classList.remove("is-open");
    }
  }

  reauth_token_check(event) {
    event.preventDefault();
    this.buttonIdValue = event.currentTarget.id;
    // `data-password-reauth-target` の値を取得して保存
    this.hasTabTargetValue = event.currentTarget.dataset.passwordReauthTarget === "tab";
    const csrfToken = document.getElementsByName("csrf-token")[0].content; // CSRFトークンを取得
    const options = {
      method: "POST", // POSTメソッドを指定
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken, // CSRFトークンを設定
      },
    };
    fetch(this.urlValue, options).then((response) => {
      if (response.ok) {
        // パスワード再認証処理をスキップ
        this.reauthSuccess();
      } else {
        // パスワード再認証モーダルを表示
        this.modalShow("password-reauth-dialog");
      }
    });
  }

  promoter_withdrawal_reauth(event) {
    event.preventDefault();
    this.buttonIdValue = event.currentTarget.id;
    this.modalShow("promoter-withdrawal-password-reauth-dialog");
  }

  withdrawal_reauth(event) {
    event.preventDefault();
    this.buttonIdValue = event.currentTarget.id;
    this.modalShow("withdrawal-password-reauth-dialog");
  }

  reauthorization(event) {
    if (event.detail.success) {
      this.modalClose();
      this.reauthSuccess();
    }
  }

  reauthSuccess() {
    var buttonTarget = document.getElementById(this.buttonIdValue);
    if (buttonTarget.type == "submit") {
      // submit処理
      buttonTarget.form.requestSubmit();
    } else if (buttonTarget.dataset.target) {
      // モーダル表示
      var target = buttonTarget.dataset.target;
      var targetModal = document.querySelector(target);
      setTimeout(function () {
        $(targetModal).fadeIn(300);
        targetModal.showModal();
        targetModal.classList.add("is-open");
        targetModal.setAttribute("tabindex", "-1");
        targetModal.focus();
      }, 400);
    } else if (buttonTarget.href) {
      // リンク処理
      var url = buttonTarget.href;
      // tab targetの有無で別ウィンドウで開くか判定
      if (this.hasTabTargetValue) {
        window.open(url, "_blank");
      } else {
        window.location.href = url;
      }
    }
  }
}
